<template>
  <div>
    <el-form label-position="top" class="u-mb-10" v-if="exibeSelectInstituicao">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="24">
          <el-form-item>
            <el-select @change="changeInstituicao" v-model="filtro.instituicao.id" filterable placeholder="Pesquisar Instituição">
              <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-row class="u-mt-10 u-mb-20">
      <el-col :xs="24" :sm="16" :md="16">
        <el-input v-model="filtro.nome" placeholder="Pesquisar monitor..." @keyup.native.enter="load"></el-input>
      </el-col>
      <el-col :xs="24" :sm="8" :md="8" class="u-text-right">
        <el-button type="primary" @click="abrirCadastro">NOVO MONITOR</el-button>
      </el-col>
    </el-row>

    <el-row :gutter="10" class="u-mb-10">
      <el-col :xs="24" :sm="16" :md="16">
        <el-input v-model="filtro.cpf" placeholder="CPF"></el-input>
      </el-col>
      <el-col :xs="24" :sm="8" :md="8" class="u-text-right">
        <el-button @click="load" type="info" plain icon="el-icon-search">FILTRAR</el-button>
      </el-col>
    </el-row>

    <div class="container-table">
      <table class="table table-striped">
        <thead>
          <tr>
            <th class="hidden-mobile" style="width: 70px;">cod</th>
            <th>Nome</th>
            <th class="hidden-mobile">CPF</th>
            <th class="hidden-mobile">Telefone</th>
            <th style="width: 180px;" class="u-text-center">Ação</th>
          </tr>
        </thead>
        <tbody v-if="statusList">
          <tr v-for="item in items" :key="item.id">
            <td class="hidden-mobile">{{ item.id }}</td>
            <td>{{ item.nome }}</td>
            <td class="hidden-mobile">{{ item.cpf || '-' }}</td>
            <td class="hidden-mobile">{{ item.telefone || '-' }}</td>
            <td class="u-text-center acao">
              <router-link :to="linkEdit(item.id)" class="link-icon u-mr-10" style="color: rgba(0, 0, 0, 0.87) !important;">
                <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
              </router-link>
              <el-button @click="deleteItem(item.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!statusList" class="u-text-center u-mt-25">
        <img src="/public/img/loading-bar.gif" />
      </div>

      <el-row :gutter="10" v-if="statusList">
        <el-col :xs="24" :sm="12" :md="12">
          <div class="u-text-left u-mt-10">
            Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros encontrados.
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > 30">
          <div class="u-text-right">
            <el-pagination :current-page="paginate.page" class="u-mt-10" :total="paginate.qtdItens"
              @current-change="getPagePagination" :page-size="30" background layout="prev, pager, next" small></el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    statusList: false,
    filtro: { instituicao_id: '', instituicao: { id: '', nome: '' }, nome: '', cpf: '' },
    paginate: { page: 1, qtdItens: null, from: '', to: '' },
    items: []
  }),
  computed: {
    exibeSelectInstituicao () {
      const t = Number(this.$store.state.user.tipo)
      return (t > 3 && t <= 8) || t === 10
    }
  },
  mounted () {
    if (this.$store.state.config.instituicao) {
      this.filtro.instituicao = { id: this.$store.state.config.instituicao.id, nome: this.$store.state.config.instituicao.nome }
    }
    this.load()
  },
  methods: {
    abrirCadastro () {
      if (!this.$store.state.config.instituicao || !this.$store.state.config.instituicao.id) {
        window.eventBus.$emit('alert', { msg: 'Selecione uma instituição antes de cadastrar um monitor.', type: 'warning' })
        return
      }
      this.$router.push({
        path: '/admin/transporte/monitor/cadastro',
        query: { instituicao_id: this.$store.state.config.instituicao.id }
      })
    },
    linkEdit (id) {
      const inst = this.$store.state.config.instituicao
      return {
        path: '/admin/transporte/monitor/edit/' + id,
        query: (inst && inst.id) ? { instituicao_id: inst.id } : {}
      }
    },
    async changeInstituicao () {
      if (this.exibeSelectInstituicao) {
        await this.$store.dispatch('setInstituicao', this.filtro.instituicao.id)
      }
      this.paginate.page = 1
      this.load()
    },
    load () {
      this.statusList = false
      this.items = []
      this.filtro.instituicao_id = this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : ''
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/monitor/getAllPaginate?page=` + this.paginate.page, this.filtro, this.$store.getters.getHeaderAuth)
        .then(response => {
          this.items = response.data.data
          this.paginate.qtdItens = response.data.total
          this.paginate.from = response.data.from
          this.paginate.to = response.data.to
          this.statusList = true
        }).catch((error) => { this.$store.commit('throwException', error) })
    },
    deleteItem (id) {
      this.$msgbox.confirm('Tem certeza que deseja excluir este monitor?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' })
        .then(() => {
          window.eventBus.$emit('loading', true)
          this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/transporte-escolar/monitor/delete/` + id, this.$store.getters.getHeaderAuth)
            .then(() => {
              window.eventBus.$emit('loading', false)
              window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
              this.load()
            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
        }).catch(() => { })
    },
    getPagePagination (page) {
      this.paginate.page = page
      this.load()
    }
  }
}
</script>

